export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11506.88a096f4.jpg";